import React from "react"
import * as Icon1 from "react-icons/bi"
import * as Icon3 from "react-icons/hi2"
import * as Icon2 from "react-icons/io5"
import { FaFacebook, FaGoogle, FaTwitter, FaLinkedin,FaInstagram,FaGithub } from "react-icons/fa";

const contactDetails = [
  {
    icon: "HiChatBubbleLeftRight",
    heading: "Chat on us",
    description: "Our friendly team is here to help.",
    details: "vikasmaheshwari6267@gmail.com",
  },
  {
    icon: "BiWorld",
    heading: "Visit us",
    description: "Come and say hello at our office HQ.",
    details:
      "Ichhawar , Sehore Madhyapradesh 466115",
  },
  {
    icon: "IoCall",
    heading: "Call us",
    description: "Mon - Fri From 8am to 5pm",
    details: "+91 6267144122",
  },
]

const ContactDetails = () => {
  return (
    <div className="flex flex-col gap-6 rounded-xl bg-richblack-800 p-4 lg:p-6">
      {contactDetails.map((ele, i) => {
        let Icon = Icon1[ele.icon] || Icon2[ele.icon] || Icon3[ele.icon]
        return (
          <div
            className="flex flex-col gap-[2px] p-3 text-sm text-richblack-200"
            key={i}
          >
            <div className="flex flex-row items-center gap-3">
              <Icon size={25} />
              <h1 className="text-lg font-semibold text-richblack-5">
                {ele?.heading}
              </h1>
            </div>
            <p className="font-medium">{ele?.description}</p>
            <p className="font-semibold">{ele?.details}</p>
          </div>
        )
      })}

      <div className="flex gap-4 text-3xl">
               <a href="https://www.facebook.com/vikasmaheshwari.vk" target="_blank" > <FaFacebook /></a>
               <a href="mailto:vikasmaheshwari6267@gmail.com" target="_blank"> <FaGoogle /></a>
               <a href="https://www.instagram.com/vikash_maheshwarii/" target="_blank"> <FaInstagram/></a>  
                <a href="https://www.linkedin.com/in/vikash-maheshwari-1191a9277/" target="_blank"> <FaLinkedin /></a>
                <a href="https://github.com/vikash6267" target="_blank"> <FaGithub /></a>
              </div>
    </div>
  )
}

export default ContactDetails
